﻿module.exports = {
    bindings: { 
        ordernumber: '<' 
    },
    controller: orderNumberButtonController,
    templateUrl: 'quota/components/ordernumber-button.html'
};

orderNumberButtonController.$inject = ['quotaModals'];

function orderNumberButtonController(quotaModals) {
    var vm = {
        showOrderNumber: showOrderNumber
    };

    function showOrderNumber() {
        quotaModals.orderQuota.show(vm.ordernumber);
    }

    return vm;

}